module.exports = __webpack_public_path__ + "img/reparatur-bonus.f29b2c02.jpg";